import { ClockWorkModule } from "@/store/modules/clockWork.module";
import { Machine, assign } from "xstate";
const clockWorkSearchMachine = Machine({
    id: "clockWorkSearch",
    context: {
        searchCharacters: "",
        skipCount: 0,
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "modalDormant",
            },
        },
        modalDormant: {
            entry: ["cleardata", "clearSkipCount"],
            on: {
                GET_RECENT_ENTRIES: { target: "modalActive" },
            },
        },
        modalActive: {
            initial: "gettingRecentItems",
            on: {
                MAKE_MODAL_DORMANT: { target: "modalDormant" },
            },
            states: {
                gettingRecentItems: {
                    tags: ["recentEntries", "gettingRecentEntries"],
                    invoke: {
                        id: "searchingEntries",
                        src: (ctx, event) => {
                            return ClockWorkModule.GettingMostRecentEntries(ctx.skipCount);
                        },
                        onDone: { target: "recentItemsLoaded" },
                        onError: { target: "#clockWorkSearch.serviceUnavailable" },
                    },
                },
                recentItemsLoaded: {
                    tags: "recentEntries",
                    on: {
                        SEARCH_ENTRIES: { target: "checkForSearchCharacters", actions: ["assignDataToSearch", "assignSkipCount"] },
                        LOAD_MORE_RECENT_ITEMS: { target: "gettingRecentItems", actions: ["assignSkipCount"] },
                    },
                },
                debouncingSearch: {
                    tags: ["debouncingSearch", "searchEntries"],
                    on: {
                        SEARCH_ENTRIES: { target: "debouncingSearch", actions: ["assignDataToSearch", "assignSkipCount"] },
                    },
                    after: {
                        1000: {
                            target: "searchingEntries",
                        },
                    },
                },
                searchingEntries: {
                    tags: ["searchEntries", "searchingEntries"],
                    invoke: {
                        id: "searchingEntries",
                        src: (ctx, event) => {
                            return ClockWorkModule.SearchInClockWorkDetails({ searchCharacters: ctx.searchCharacters, skip: ctx.skipCount });
                        },
                        onDone: { target: "searchResultsLoaded" },
                        onError: { target: "#clockWorkSearch.serviceUnavailable" },
                    },
                },
                searchResultsLoaded: {
                    tags: "searchEntries",
                    on: {
                        SEARCH_ENTRIES: [
                            {
                                target: "checkForSearchCharacters",
                                actions: ["assignDataToSearch", "assignSkipCount"],
                            },
                            {
                                target: "checkForSearchCharacters",
                                actions: ["assignDataToSearch", "assignSkipCount"],
                            },
                        ],
                        LOAD_MORE_SEARCH_ENTRIES: { target: "debouncingSearch", actions: ["assignDataToSearch", "assignSkipCount"] },
                        CLEAR_SEARCH_CHARACTER: { target: "gettingRecentItems" },
                    },
                },
                checkForSearchCharacters: {
                    tags: ["checkForSearchCharacters", "searchEntries"],
                    always: [
                        {
                            cond: "checkSearchCharacterForEmpty",
                            target: "gettingRecentItems",
                        },
                        {
                            cond: "checkSearchCharacterForNotEmpty",
                            target: "debouncingSearch",
                        },
                    ],
                },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    guards: {
        checkSearchCharacterForEmpty: (context, event) => {
            return context.searchCharacters.trim() == "";
        },
        checkSearchCharacterForNotEmpty: (context, event) => {
            return context.searchCharacters.trim() != "";
        },
    },
    actions: {
        assignDataToSearch: assign({
            searchCharacters: (context, event) => event.str,
        }),
        assignSkipCount: assign({
            skipCount: (context, event) => event.skipCount,
        }),
        clearSkipCount: assign({
            skipCount: (context, event) => (event.skipCount = 0),
        }),
        cleardata: () => {
            ClockWorkModule.clearTotalCount();
            ClockWorkModule.ClearFilterEntries();
        },
    },
});
export default clockWorkSearchMachine;
